export default {
      id: "tremezzo-drawer-open-usage",
      viewBox: "0 0 948 723",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#tremezzo-drawer-open",
      toString: function () {
        return this.url;
      }
    }